import { render, staticRenderFns } from "./solution1.vue?vue&type=template&id=88faf888&scoped=true"
import script from "./solution1.vue?vue&type=script&lang=js"
export * from "./solution1.vue?vue&type=script&lang=js"
import style0 from "./solution1.vue?vue&type=style&index=0&id=88faf888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88faf888",
  null
  
)

export default component.exports